"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeAmplitude = exports.isAllowedEnv = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const isAllowedEnv = (env, allowedEnvs) => {
    return !!env && allowedEnvs.includes(env);
};
exports.isAllowedEnv = isAllowedEnv;
const initializeAmplitude = async ({ amplitudeKey, env, allowedEnvs, }) => {
    if (!(0, exports.isAllowedEnv)(env, allowedEnvs)) {
        return;
    }
    if (!amplitudeKey) {
        console.warn('Amplitude Key is not set. Skipping initialization.');
        return;
    }
    try {
        const [amplitudeSdk, sessionReplaySdk] = await Promise.all([
            Promise.resolve().then(() => __importStar(require('@amplitude/analytics-browser'))),
            Promise.resolve().then(() => __importStar(require('@amplitude/plugin-session-replay-browser'))),
        ]);
        const sessionReplayPlugin = sessionReplaySdk.plugin({ sampleRate: 0.1 });
        amplitudeSdk.add(sessionReplayPlugin);
        // Sync Segment user data with Amplitude
        let deviceId = '';
        if (window.analytics) {
            const segmentUser = await Promise.resolve(window.analytics.user());
            deviceId = `${segmentUser.anonymousId()}`;
        }
        // Set hubspot cookie as a user property
        const hubspotutk = js_cookie_1.default.get('hubspotutk');
        if (hubspotutk) {
            const identifyEvent = new amplitudeSdk.Identify();
            identifyEvent.set('hubspotutk', hubspotutk);
            amplitudeSdk.identify(identifyEvent);
        }
        await amplitudeSdk.init(amplitudeKey, {
            remoteConfig: {
                fetchRemoteConfig: false,
            },
            autocapture: false, // We do not track user events with Amplitude
            deviceId: deviceId || undefined,
        }).promise;
    }
    catch (error) {
        console.error('Failed to load or initialize Amplitude SDK:', error);
    }
};
exports.initializeAmplitude = initializeAmplitude;
